export const subs = {
    'fPork': 'Schweinefleisch',
    'fBeef': 'Rindfleisch',
    'fOther': 'Anderes Fleisch',

    'lV': 'Vegetarisch',
    'lVplus': 'Vegan',
    'lBIO': 'Bio',
    'lKOSCH': 'Koscher',
    'lAy': 'Ayurveda',
    'lHal': 'Halal',

    'aA': 'Gluten',
    'aB': 'Krebstiere',
    'aC': 'Eier von Geflügel',
    'aD': 'Fisch',
    'aE': 'Erdnüsse',
    'aF': 'Sojabohnen',
    'aG': 'Milch und Milcherzeugnisse',
    'aH': 'Schalenfrüchte',
    'aL': 'Sellerie',
    'aM': 'Senf',
    'aN': 'Sesamen',
    'aO': 'Schwefeloxid und Sulfite',
    'aP': 'Lupinen',
    'aR': 'Weichtiere',

    // aV: false,
    // aVplus: false,
    // aBIO: false,
    // aSW: false

    'z1': 'Konservierungsstoff',
    'z2': 'Geschmacksverstärker',
    'z3': 'Antioxidationsmittel',
    'z4': 'Farbstoff',
    'z5': 'Phosphat',
    'z6': 'chininhaltig',
    'z7': 'koffeinhaltig',
    'z8': 'geschwefelt',
    'z9': 'Saccharin',
    'z10': 'Aspartam/ Phenylalaninquelle',
    'z11': 'Cyclamat',
    'z12': 'Acesulfam',
    'z13': 'geschwärzt',
    'z14': 'gewachst',
    'z15': 'gentechnisch',

}